import { ALERT_SHOW, ALERT_CLOSE } from "constants/action-types";

const initialState = {
  message: "",
  visible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ALERT_SHOW:
      return {
        message: action.payload.message,
        visible: true
      };

    case ALERT_CLOSE:
      return {
        ...state,
        visible: false
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/common/alert.js